import { CountryIconProps } from './types';

const UZ = ({ dimension }: CountryIconProps) => (
  <svg
    width={dimension || 24}
    height={dimension || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1046_3725)">
      <path
        d="M0.566625 8.34794C0.199031 9.49956 -4.68667e-05 10.7264 8.27601e-09 12C-4.68667e-05 13.2736 0.199078 14.5005 0.566672 15.6521L12 16.174L23.4333 15.6522C23.8009 14.5006 24.0001 13.2736 24.0001 12.0001C24 10.7265 23.8009 9.49956 23.4333 8.34789L12 7.82617L0.566625 8.34794Z"
        fill="#F0F0F0"
      />
      <path
        d="M23.4332 8.34789L11.9999 7.82617L0.5665 8.34789C0.457563 8.68933 0.363766 9.03747 0.285156 9.39137H23.7144C23.6359 9.03742 23.5421 8.68923 23.4332 8.34789Z"
        fill="#D80027"
      />
      <path
        d="M0.285156 14.609C0.363672 14.9629 0.457469 15.311 0.566406 15.6524L0.567531 15.6525L11.9997 16.1742L23.433 15.6525C23.542 15.3111 23.6358 14.9629 23.7143 14.609H0.285156Z"
        fill="#D80027"
      />
      <path
        d="M12.0007 24.0007C17.3545 24.0007 21.8888 20.4943 23.434 15.6528H0.567383C2.11262 20.4942 6.64693 24.0007 12.0007 24.0007Z"
        fill="#6DA544"
      />
      <path
        d="M11.9997 -0.000854492C6.64595 -0.000807617 2.11173 3.50558 0.566406 8.34697L23.433 8.34702C21.8879 3.50554 17.3536 -0.000901367 11.9997 -0.000854492Z"
        fill="#338AF3"
      />
      <path
        d="M5.48376 4.95618C5.48376 3.83226 6.27365 2.89335 7.32847 2.66301C7.16638 2.62757 6.99815 2.6084 6.82536 2.6084C5.52871 2.6084 4.47754 3.65952 4.47754 4.95623C4.47754 6.25293 5.52862 7.30406 6.82536 7.30406C6.99815 7.30406 7.16633 7.28484 7.32847 7.24945C6.27369 7.01901 5.48376 6.0801 5.48376 4.95618Z"
        fill="#F0F0F0"
      />
      <path
        d="M8.71531 6.02246L8.87421 6.5116H9.38853L8.97246 6.81395L9.13137 7.30309L8.71531 7.00079L8.29915 7.30309L8.4581 6.81395L8.04199 6.5116H8.55631L8.71531 6.02246Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.3578 6.02246L10.5167 6.5116H11.0311L10.6149 6.81395L10.7739 7.30309L10.3578 7.00079L9.94168 7.30309L10.1006 6.81395L9.68457 6.5116H10.1988L10.3578 6.02246Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.9995 6.02246L12.1584 6.5116H12.6728L12.2566 6.81395L12.4156 7.30309L11.9995 7.00079L11.5833 7.30309L11.7423 6.81395L11.3262 6.5116H11.8405L11.9995 6.02246Z"
        fill="#F0F0F0"
      />
      <path
        d="M13.6411 6.02246L13.8 6.5116H14.3143L13.8982 6.81395L14.0572 7.30309L13.6411 7.00079L13.2249 7.30309L13.3839 6.81395L12.9678 6.5116H13.4821L13.6411 6.02246Z"
        fill="#F0F0F0"
      />
      <path
        d="M15.2826 6.02246L15.4415 6.5116H15.9559L15.5398 6.81395L15.6987 7.30309L15.2826 7.00079L14.8665 7.30309L15.0254 6.81395L14.6094 6.5116H15.1236L15.2826 6.02246Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.3578 4.31506L10.5167 4.80416H11.0311L10.6149 5.10655L10.7739 5.59564L10.3578 5.29335L9.94168 5.59564L10.1006 5.10655L9.68457 4.80416H10.1988L10.3578 4.31506Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.9995 4.31506L12.1584 4.80416H12.6728L12.2566 5.10655L12.4156 5.59564L11.9995 5.29335L11.5833 5.59564L11.7423 5.10655L11.3262 4.80416H11.8405L11.9995 4.31506Z"
        fill="#F0F0F0"
      />
      <path
        d="M13.6411 4.31506L13.8 4.80416H14.3143L13.8982 5.10655L14.0572 5.59564L13.6411 5.29335L13.2249 5.59564L13.3839 5.10655L12.9678 4.80416H13.4821L13.6411 4.31506Z"
        fill="#F0F0F0"
      />
      <path
        d="M15.2826 4.31506L15.4415 4.80416H15.9559L15.5398 5.10655L15.6987 5.59564L15.2826 5.29335L14.8665 5.59564L15.0254 5.10655L14.6094 4.80416H15.1236L15.2826 4.31506Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.9995 2.60803L12.1584 3.09722H12.6728L12.2566 3.39952L12.4156 3.8887L11.9995 3.58641L11.5833 3.8887L11.7423 3.39952L11.3262 3.09722H11.8405L11.9995 2.60803Z"
        fill="#F0F0F0"
      />
      <path
        d="M13.6411 2.60803L13.8 3.09722H14.3143L13.8982 3.39952L14.0572 3.8887L13.6411 3.58641L13.2249 3.8887L13.3839 3.39952L12.9678 3.09722H13.4821L13.6411 2.60803Z"
        fill="#F0F0F0"
      />
      <path
        d="M15.2826 2.60803L15.4415 3.09722H15.9559L15.5398 3.39952L15.6987 3.8887L15.2826 3.58641L14.8665 3.8887L15.0254 3.39952L14.6094 3.09722H15.1236L15.2826 2.60803Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_1046_3725">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default UZ;
